export default {
	"ordersMultiple": {
		"lasterStartTime": "เวลาเริ่มต้นล่าสุด",
		"lasterFinishTime": "เวลาดำเนินการแล้วเสร็จล่าสุด",
		"taskDetail": "รายละเอียดงาน",
		"actualPackingQty": "จำนวนบรรจุภัณฑ์จริง",
		"warningTimes": "จำนวนการแจ้งเตือน",
		"completeBackDt": "เวลาที่ได้รับครบถ้วนสมบูรณ์",
		"finishLocationQty": "จำนวนสถานที่ที่ดำเนินการแล้วเสร็จ",
		"finishTransportQty": "จำนวนงานที่ดำเนินการแล้วเสร็จ",
		"processInformation": "ข้อมูลกระบวนการ",
		"BillingStatus": "สถานะการเรียกเก็บเงิน",
		"settlementTime": "เวลาชำระเงิน",
		"reckoner": "clearing party",
		"payor": "ผู้รับเงิน"
	},
	"ordersSingle": {
		"transportStop": "สินค้าถูกยกเลิก",
		"changeTransport": "เปลี่ยนเส้นทาง",
		"demandInfo": "ข้อมูลความต้องการ",
		"receiving": "การรับสินค้า",
		"taskExecutPreview": "รายการดำเนินการงาน",
		"executeInfo": "ข้อมูลการดำเนินการ",
		"signName": "ผู้ลงนาม",
		"backRemarks": "หมายเหตุการรับ",
		"commonbackCheckedStatus": "สถานะการรับ"
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/orders/orders.js